export const capitalizeFirstLetter = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export const shortenString = (string, characters) => {
  return (string.length > characters) ? string.slice(0, characters - 1) + '...' : string
}